<script>
  export default {
    name: "ConfirmDialog",
    props: {
      title: {
        type: String,
        required: false
      },

      text: {
        type: String,
        required: false
      },

      centerText: {
        type: Boolean,
        default: false
      },

      confirmText: {
        type: String,
        required: true
      },

      cancelText: {
        type: String,
        required: false
      }
    },
    functional: true,

    render(createElement, context) {
      // check slots
      if (context.children.length !== 1) {
        console.error('Must have exactly one child element in ConfirmDialog!');
        return null;
      }

      const store = context.parent.$store;
      const el  = context.children[0];

      const { confirm } = context.listeners;
      // create a listener callback to apply to the button
      const wrappedListener = () => {
        let promptPayload = context.props;
        promptPayload.component = './ConfirmDialogTemplate';
        promptPayload.confirm = confirm;

        store.dispatch('modal/showPrompt', promptPayload);
      };

      const data = (el.data || {});
      const on = (data.on || (data.on = {}));
      on.click = wrappedListener;
      el.data = data;

      return el;
    }
  }
</script>
